import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { accountSchema } from '../schemas/account.schema';

/**
 * Get a list of accounts tied to an application
 * @param applicationName application name
 * @returns array of accounts tied to an application
 */
export function getAccountsApplication(this: unknown, applicationName: string) {
  const params = new URLSearchParams([['applicationName', applicationName]]);
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).accountsApplicationUrl
      }?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(accountSchema)));
}
